import { Autorenew } from "@mui/icons-material";
import { OAuthResponseType, TokenManager } from "@okta/okta-auth-js";

const getOktaConfig = (): Record<string, any> => {
  const clientId = process.env.REACT_APP_OKTA_CLIENT;
  const redirectUri = process.env.REACT_APP_OKTA_REDIRECT;
  const oktaDomain = process.env.REACT_APP_OKTA_ISSUER;
  
  const basename = process.env.REACT_APP_BASENAME || "";
  const oktaTestingDisableHttpsCheck = process.env.OKTA_TESTING_DISABLEHTTPSCHECK || false;
  const useClassicEngine = process.env.USE_CLASSIC_ENGINE === "true" || false;
  
  return {
    oidc: {
      issuer: `${oktaDomain}`,
      clientId: clientId,
      redirectUri: redirectUri,
      scopes: ["openid", "profile", "email", "offline_access", "https://www.viubyhub.com/organizationmanagementapi/full"],
      pkce: true,
      responseType: "code" as OAuthResponseType,
      disableHttpsCheck: oktaTestingDisableHttpsCheck,
      useClassicEngine: useClassicEngine,

    },
    widget: {
      baseUrl: oktaDomain,
      clientId: clientId,
      redirectUri: redirectUri,
      authParams: {
        issuer: `${oktaDomain}`,
        display: "page",
        scopes: ["openid", "profile", "email", "offline_access", "https://www.viubyhub.com/organizationmanagementapi/full"],
        pkce: true,
        responseType: "code",
      },
      useClassicEngine: useClassicEngine,
    },
    resourceServer: {
      messagesUrl: "http://localhost:8000/api/messages",
    },
    app: {
      basename: basename,
    },
  };
}

export default getOktaConfig;
